'use client';

import { IC_CHEVRON_LEFT, IC_CHEVRON_RIGHT } from '@/assets/icons';
import dynamic from 'next/dynamic';
import { useRef, useState } from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import styles from './product.module.scss';
import Offer from '@/components/molecules/Offers';

const OffersModule = ({ data: { offers } }: any) => {
	const swiperRef = useRef<SwiperRef | null>(null);
	const [allowSlide, setAllowSlide] = useState({
		allowSlidePrev: false,
		allowSlideNext: true
	});
	return (
		<div className={styles.offer_slider}>
			<div className='d-flex justify-space-between items-center'>
				<div className='text-24 text-grey900 fw-600 mb-5'>Additional Offers</div>
				<div className='d-flex'>
					<button
						className={styles.previous}
						disabled={!allowSlide.allowSlidePrev}
						onClick={() => {
							const swiperInstance = swiperRef.current?.swiper;
							swiperInstance?.slidePrev();
						}}>
						<IC_CHEVRON_LEFT />
					</button>
					<button
						className={styles.next}
						disabled={!allowSlide.allowSlideNext}
						onClick={() => {
							const swiperInstance = swiperRef.current?.swiper;
							swiperInstance?.slideNext();
						}}>
						<IC_CHEVRON_RIGHT />
					</button>
				</div>
			</div>

			<div className='container p-0'>
				<Swiper
					ref={swiperRef}
					onSlideChange={(e) => {
						setAllowSlide({
							allowSlidePrev: !e.isBeginning,
							allowSlideNext: !e.isEnd
						});
					}}
					modules={[Autoplay]}
					slidesPerView={1.5}
					spaceBetween={20}
					autoplay={{
						delay: 2500,
						disableOnInteraction: false,
						pauseOnMouseEnter: true
					}}
					className={'offers_continer'}
					pagination={true}>
					{offers?.map((d: any, i: number) => {
						return (
							<SwiperSlide key={i} className={`slider_wrap py-10 `}>
								<Offer offer={d} index={i} />
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
		</div>
	);
};

const Offers = dynamic(() => Promise.resolve(OffersModule), {
	ssr: true
});

export default Offers;
